import { render, staticRenderFns } from "./moduleSix.vue?vue&type=template&id=12aea058"
import script from "./moduleSix.vue?vue&type=script&lang=js"
export * from "./moduleSix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports